const commonStyle = {
  fontSize: 15,
  lineHeight: 1.4,
  fontFamily: 'inherit',
  color: '#211E26', 
};

const facebookMention = {
  backgroundColor: '#D1E7FF', 
  borderRadius: 3,
  fontWeight: 600,
  // Mantenemos esto transparente para que no choque con el texto del input
  color: 'transparent',       
};

export const mentionsStylePost = {
  control: commonStyle,
  '&multiLine': {
    control: { fontFamily: 'inherit', minHeight: 60 },
    highlighter: { 
      padding: 12, 
      border: '1px solid transparent',
      // CAMBIO AQUÍ: El texto del resaltador debe ser transparente
      color: 'transparent', 
    },
    input: { 
      padding: 12, 
      border: 'none', 
      outline: 'none',
      color: '#211E26', 
      zIndex: 1,
    },
  },
  suggestions: {
    list: { backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: 8, zIndex: 9999 },
    item: { padding: '10px 15px', '&focused': { backgroundColor: '#1877f2', color: '#fff' } },
  },
  mention: facebookMention,
};

export const mentionsStyleComments = {
  control: {
    fontSize: 14,
    lineHeight: 1.2,
    fontFamily: 'inherit',
  },
  '&multiLine': {
    control: { fontFamily: 'inherit', minHeight: 30 },
    highlighter: { 
      padding: 9, 
      border: '1px solid transparent',
      // CAMBIO AQUÍ: También transparente en comentarios
      color: 'transparent', 
    },
    input: { 
      padding: 9, 
      border: 'none', 
      outline: 'none',
      color: '#211E26', 
      zIndex: 1,
    },
  },
  suggestions: {
    list: { backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: 8, zIndex: 9999 },
    item: { padding: '8px 12px', '&focused': { backgroundColor: '#1877f2', color: '#fff' } },
  },
  mention: facebookMention,
};